// @owners { team: patients-team }
import { COLORS } from '@alto/design-library-tokens';
import { Body, Button, LandingPage } from '@alto/design-system';
import { useQueryLandingPageConfigs } from '@alto/features';
import React from 'react';
import { getImage } from '~shared/assets/images/getImage';
import { getCompanyName } from '~shared/config/getCompanyName';
import { IMG_ALT_TEXTS } from '~shared/constants';
import { getIsCurrentUserFertility } from '~shared/features/users/selectors/getIsFertilityUser';
import { useSelectorShared } from '~shared/store';
import { OnboardingNavBarLogo } from '~web/features/onboarding/components/redesign/OnboardingNavBarLogo';

type Props = {
  readonly handleGetStarted: () => void;
  readonly loading: boolean;
  readonly tempPassword: string;
};

export const WebLandingPage = ({ handleGetStarted, loading, tempPassword }: Props) => {
  const { isFetching, welcomeBody, welcomeHeader, headerLogoUrl } = useQueryLandingPageConfigs({ tempPassword });
  const showFertility = useSelectorShared(getIsCurrentUserFertility);
  const subtitle = showFertility
    ? "We're here for you at every step of your fertility journey."
    : (welcomeBody ?? 'Extraordinary care and convenience for a healthier life.');
  if (isFetching) {
    return null;
  }
  return (
    <LandingPage
      withoutWebFramingElementHeights
      footerPlacementContext="webScreenWithoutPolicyFooter"
      HeaderBodyCopy={<Body>{subtitle}</Body>}
      backgroundColor={COLORS.BACKGROUND_COLORS.TERTIARY_LIGHTEST}
      NavBarCenterContent={<OnboardingNavBarLogo illustrationSrc={headerLogoUrl} />}
      title={welcomeHeader || `Welcome to ${getCompanyName()}`}
      illustrationSrc={getImage('onboardingWelcome')}
      illustrationSize="xxl"
      illustrationAccessibilityLabel={IMG_ALT_TEXTS.onboardingWelcome}
      buttons={[
        <Button
          label="Get started"
          key="get-started"
          loading={loading}
          onPress={handleGetStarted}
        />,
      ]}
    ></LandingPage>
  );
};
